var _defs, _path, _path2, _path3, _polygon, _path4, _path5, _path6, _polygon2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect, _path14, _path15, _path16, _path17, _path18, _path19, _rect2, _polygon3, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _polygon4, _path29, _path30, _path31, _path32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellow2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 74 126.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19{stroke-width:0px;}.cls-1,.cls-20{fill:none;}.cls-2{fill:url(#linear-gradient);}.cls-20{stroke:#d2838d;stroke-miterlimit:10;}.cls-3{fill:url(#linear-gradient-4);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-8);}.cls-7{fill:url(#linear-gradient-9);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-5);}.cls-10{fill:url(#linear-gradient-6);}.cls-11{fill:#f56f51;}.cls-12{fill:#23ecd8;}.cls-13{fill:#121413;}.cls-14{fill:#d2838d;}.cls-15{fill:#c65d6f;}.cls-16{fill:#b46470;}.cls-17{fill:#fff;}.cls-18{fill:#ffc130;}.cls-19{fill:#00c6b5;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2968.19,
    y1: 2563.22,
    x2: 2976.67,
    y2: 2563.22,
    gradientTransform: "translate(3205.59 2289.17) rotate(-103.89) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9b98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#f9b3b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#f6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f3d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f1dcdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1dfe0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2974.11,
    y1: 2563.31,
    x2: 2976.12,
    y2: 2563.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2156.53,
    y1: -718.78,
    x2: 2165,
    y2: -718.78,
    gradientTransform: "translate(249.29 2289.17) rotate(-76.11)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2162.45,
    y1: -718.7,
    x2: 2164.46,
    y2: -718.64,
    gradientTransform: "translate(249.29 2289.17) rotate(-76.11)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 38.53,
    y1: 33.81,
    x2: 38.53,
    y2: 45.52,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 53.93,
    y1: 16.07,
    x2: 53.62,
    y2: 25.57,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 23.92,
    y1: 16.18,
    x2: 24.31,
    y2: 25.86,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 38.83,
    y1: 15.46,
    x2: 38.83,
    y2: 34.02,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -4362.99,
    y1: 7.35,
    x2: -4363.61,
    y2: 37.27,
    gradientTransform: "translate(-4324.31) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f56f51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f47053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f2765b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#f08069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ec8d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#e79f97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#e6a59f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m18.14,114.74l7.27-.26,1.24-19.37c.17-2.63-1.97-4.84-4.61-4.75h0c-2.44.09-4.35,2.11-4.3,4.55l.41,19.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m27.75,81.03l-8.79,10.54c-1.74,2.08-1.43,5.18.67,6.89h0c1.94,1.57,4.75,1.41,6.51-.36l9.7-9.81c2.02-2.04,1.84-5.38-.4-7.19l-.9-.73c-2.06-1.67-5.08-1.37-6.78.66Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m27.67,76.3h22.25v5.21c0,3.04-2.47,5.51-5.51,5.51h-11.24c-3.04,0-5.51-2.47-5.51-5.51v-5.21h0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.61 21.69 6.24 20.22 6.77 19.31 6.25 15.66 5.87 14.14 4.28 14.53 4.39 15.22 3.13 15.41 2.05 15.65 1.07 15.99 1.12 16.21 1.02 15.81 0 15.98 .1 16.82 0 17.58 1.1 20.85 2.18 21.49 2.67 23.66 6.83 22.63 6.61 21.69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m5.5,16.15l-1.25-.12s-.03,0-.04.01l-.68.58s-.05.02-.06,0l-.39-.29s-.03-.01-.05,0l-.43.18-.43.18s-.01,0-.02,0l-.53-.02s-.02,0-.03.01l-.95.76,1.04-.62s.02,0,.03,0l.48.05s.02,0,.03,0l.35-.22s0,0,.01,0l.39-.13s.03,0,.04,0l.46.28s.04.01.06,0l.7-.61s.02-.01.03-.01l1.23-.02Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m10.34,42.33h0c1.76-.65,2.67-2.6,2.03-4.36l-5.36-16.52-4.94,1.55,3.79,16.89c.45,2,2.56,3.15,4.48,2.44Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m6.11,37.74h0c.71-1.72,2.61-2.61,4.38-2.05l17.43,5.51c2.67.84,4.04,3.79,2.98,6.37h0c-1.04,2.52-3.97,3.67-6.44,2.51l-16.56-7.74c-1.73-.81-2.52-2.83-1.79-4.6Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "67.39 21.69 67.75 20.22 67.23 19.31 67.75 15.66 68.13 14.14 69.72 14.53 69.61 15.22 70.87 15.41 71.94 15.65 72.93 15.99 72.88 16.21 72.98 15.81 74 15.98 73.9 16.82 73.99 17.58 72.9 20.85 71.81 21.49 71.33 23.66 67.17 22.63 67.39 21.69"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m68.5,16.15l1.25-.12s.03,0,.04.01l.68.58s.05.02.06,0l.39-.29s.03-.01.05,0l.43.18.43.18s.01,0,.02,0l.53-.02s.02,0,.03.01l.95.76-1.04-.62s-.02,0-.03,0l-.48.05s-.02,0-.03,0l-.35-.22s0,0-.01,0l-.39-.13s-.03,0-.04,0l-.46.28s-.04.01-.06,0l-.7-.61s-.02-.01-.03-.01l-1.23-.02Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m63.66,42.33h0c-1.76-.65-2.67-2.6-2.03-4.36l5.36-16.52,4.94,1.55-3.79,16.89c-.45,2-2.56,3.15-4.48,2.44Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m67.89,38.08h0c-.71-1.72-2.61-2.61-4.38-2.05l-17.43,5.51c-2.67.84-4.04,3.79-2.98,6.37h0c1.04,2.52,3.97,3.67,6.44,2.51l16.56-7.74c1.73-.81,2.52-2.83,1.79-4.6Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m22.18,112.71c1.2-.04,2.21.91,2.22,2.12.01,1.66.05,3.87.15,5.27.16,2.24.2,5.57.2,5.57,0,0-11.61,1.41-14.1,1.12,0,0-.04-4.59,4.53-5.12,4.57-.53,5.44-.32,5.44-.32l-.5-6.34c-.1-1.21.84-2.26,2.06-2.31h0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m24.71,121.68c-1.26,1.02-1.83,2.42-2.09,3.43-.08.3-.12.56-.16.77,1.41-.16,2.36-.27,2.36-.27,0,0,0-.25-.01-.67-.01-.75-.04-2.01-.1-3.26Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m21.81,122.39l-.2-5.67-1.35.05.36,4.6s-.88-.22-5.44.32c-.43.05-.82.14-1.17.25l.93,1.04c2.83-1.48,6.87-.58,6.87-.58Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m22.59,125.17c-3.37.24-9.18.61-9.18.61-.11-1.56-.54-2.44-1-2.93-1.74,1.53-1.72,3.95-1.72,3.95,1.78.2,8.21-.46,11.74-.85,1.41-.16,2.36-.27,2.36-.27,0,0,0-.25-.01-.67-.33.03-1.14.09-2.19.17Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 16.76,
    y: 112.43,
    width: 9.01,
    height: 3.84
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m59.65,114.23l-7.27-.26-1.24-19.37c-.17-2.63,1.97-4.84,4.61-4.75h0c2.44.09,4.35,2.11,4.3,4.55l-.41,19.82Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m50.03,80.52l8.79,10.54c1.74,2.08,1.43,5.18-.67,6.89h0c-1.94,1.57-4.75,1.41-6.51-.36l-9.7-9.81c-2.02-2.04-1.84-5.38.4-7.19l.9-.73c2.06-1.67,5.08-1.37,6.78.66Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m55.6,112.2c-1.2-.04-2.21.91-2.22,2.12-.01,1.66-.05,3.87-.15,5.27-.16,2.24-.2,5.57-.2,5.57,0,0,11.61,1.41,14.1,1.12,0,0,.04-4.59-4.53-5.12-4.57-.53-5.44-.32-5.44-.32l.5-6.34c.1-1.21-.84-2.26-2.06-2.31h0Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m53.07,121.18c1.26,1.02,1.83,2.42,2.09,3.43.08.3.12.56.16.77-1.41-.16-2.36-.27-2.36-.27,0,0,0-.25.01-.67.01-.75.04-2.01.1-3.26Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m55.97,121.88l.2-5.67,1.35.05-.36,4.6s.88-.22,5.44.32c.43.05.82.14,1.17.25l-.93,1.04c-2.83-1.48-6.87-.58-6.87-.58Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m55.19,124.66c3.37.24,9.18.61,9.18.61.11-1.56.54-2.44,1-2.93,1.74,1.53,1.72,3.95,1.72,3.95-1.78.2-8.21-.46-11.74-.85-1.41-.16-2.36-.27-2.36-.27,0,0,0-.25.01-.67.33.03,1.14.09,2.19.17Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 52.01,
    y: 111.92,
    width: 9.01,
    height: 3.84,
    transform: "translate(113.03 227.68) rotate(-180)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "42.2 42.51 34.87 42.51 35.89 32.55 41.18 32.55 42.2 42.51"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m54.85,44.11c.13-1.29-.43-2.62-1.56-3.25-.37-.2-.78-.34-1.21-.39l-10.2-1.24s-.24,2.2-3.35,2.2-3.35-2.2-3.35-2.2l-10.2,1.24c-.44.05-.85.19-1.21.39-1.14.63-1.7,1.96-1.56,3.26l3.98,36.53h24.87l3.79-36.54Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m52.32,15.41l3.41-.41c.12-.03.23.06.24.18l-.24,7.27c0,.08-.03.15-.1.19l-1.6.93c-.05.03-.11.04-.17.02l-2.03-.72c-.08-.03-.14-.11-.13-.2l.46-7.08c0-.09.07-.16.16-.18Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m25.58,15.52l-3.41-.41c-.12-.03-.23.06-.24.18l.24,7.27c0,.08.03.15.1.19l1.6.93c.05.03.11.04.17.02l2.03-.72c.08-.03.14-.11.13-.2l-.46-7.08c0-.09-.07-.16-.16-.18Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m38.83,12.67h-12.51c-.85,0-1.53.69-1.53,1.53v9.54c0,3.06,1.71,5.86,4.42,7.26l5.87,3.03c2.35,1.21,5.15,1.21,7.5,0l5.87-3.03c2.72-1.4,4.42-4.2,4.42-7.26v-9.54c0-.85-.69-1.53-1.53-1.53h-12.51Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m28.2,40.03s4.49,13.07-3.66,25.54l.3,2.65s14.76-10.98,8.23-28.71c0,0-4.25.2-4.87.51Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m49.53,40.03s-5.06,13.14,3.09,25.61l-.27,2.6s-14.22-11-7.69-28.73c0,0,4.25.2,4.87.51Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.8,82.66c-1.78.03-1.78,2.2-1.78,2.2l-.02.16h3.58l-.02-.23s.02-2.16-1.77-2.13Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m37.56,46.72h2.47c6.26,0,11.34,5.08,11.34,11.34v11.53c0,3.23-2.62,5.85-5.85,5.85h-13.44c-3.23,0-5.85-2.62-5.85-5.85v-11.53c0-6.26,5.08-11.34,11.34-11.34Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m29.64,63.93h19.3v7.52c0,.51-.42.93-.93.93h-17.45c-.51,0-.93-.42-.93-.93v-7.52h0Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "29.64 62.41 48.95 62.41 49.51 64.38 28.96 64.38 29.64 62.41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m35.51,48.78s-.05-4.53,2.75-4.56,3.06,4.16,3.06,4.16l-5.8.4Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m38.73,35.82l9.17-1.05c1.68-.19,3.24-.99,4.37-2.25h0c1.03-1.15,1.65-2.61,1.76-4.14l1.13-12.88c.1-1.38-.48-2.71-1.55-3.58l-3.67-2.98c-.47-.38-1.01-.66-1.59-.81l-8.51-2.24c-.58-.15-1.18-.18-1.77-.08l-6.6,1.1c-.4.07-.79.19-1.15.37l-5.44,2.65c-1.45.71-2.38,2.18-2.38,3.8v1.37s.21,6.13.21,6.13c0,.22.03.44.07.65l.79,7.09c.32,1.67,1.24,3.16,2.59,4.19l.59.45c1.09.84,2.4,1.33,3.77,1.42l6.96.82c.42.03.83.02,1.25-.03Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m53,11.59l2.3.32c.28.04.53-.15.57-.43l.14-1.02c.04-.28-.15-.53-.43-.57l-1.39-.2,2.52-1.11c.23-.1.35-.36.28-.6l-.22-.79c-.08-.29-.4-.45-.68-.33l-1.6.66,3.83-3.46c.22-.2.22-.55,0-.75l-1.04-.96c-.23-.21-.58-.17-.76.08l-2.96,4.21,1.67-4.95c.08-.23-.02-.49-.23-.6l-.83-.46c-.29-.16-.65,0-.74.31l-1.21,4.48-.04-2.74c0-.31-.28-.54-.59-.49l-1.1.18c-.28.05-.47.31-.42.6l.5,2.6-1.56-1.41c-.16-.15-.4-.17-.58-.07l-.63.35c-.19.11-.3.33-.25.55l.31,3,5.14,3.6Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m25.59,11.01l-2.31.58-.7-1.7c-.04-.28.15-.53.43-.57l1.39-.2-2.52-1.11c-.23-.1-.35-.36-.28-.6l.22-.79c.08-.29.4-.45.68-.33l1.6.66-3.83-3.46c-.22-.2-.22-.55,0-.75l1.04-.96c.23-.21.58-.17.76.08l2.96,4.21-1.67-4.95c-.08-.23.02-.49.23-.6l.83-.46c.29-.16.65,0,.74.31l1.21,4.48.04-2.74c0-.31.28-.54.59-.49l1.1.18c.28.05.47.31.42.6l-.5,2.6,1.56-1.41c.16-.15.4-.17.58-.07l.63.35c.19.11.3.33.25.55v2.96s-5.45,3.64-5.45,3.64Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellow2);
export default __webpack_public_path__ + "static/media/yellow_2.7e8b090d231087f4a413cefe70dce1d9.svg";
export { ForwardRef as ReactComponent };